import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Vishanth Pishati. Built with React & Tailwind CSS.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;